import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, {
  type WorkspaceAgentThreadCreatedLocation,
  type WorkspaceAgentThreadReopenedFrom,
  type WorkspaceAgentThreadReopenedStatus,
} from './useTrackAgentThreadOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type {
  WorkspaceAgentThreadCreatedLocation,
  WorkspaceAgentThreadOpenedType,
  WorkspaceAgentThreadReopenedFrom,
  WorkspaceAgentThreadReopenedStatus,
} from './useTrackAgentThreadOpened.meta';

type ExistingWorkspaceAgentThreadOpenedParams = {
  reopened_from?: WorkspaceAgentThreadReopenedFrom;
  status: WorkspaceAgentThreadReopenedStatus;
  type: 'existing';
};

export type UseTrackAgentThreadOpenedParams =
  | {
      is_first_run_walkthrough: boolean;
      location: WorkspaceAgentThreadCreatedLocation;
      session_id: string;
      type: 'new';
    }
  | (ExistingWorkspaceAgentThreadOpenedParams & {
      is_first_run_walkthrough: true;
    })
  | (ExistingWorkspaceAgentThreadOpenedParams & {
      is_first_run_walkthrough: false;
      session_id: string;
    });

export const useTrackAgentThreadOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentThreadOpened = useCallback(
    (params: UseTrackAgentThreadOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentThreadOpened };
};
